import { useEffect } from "react";
import { useThemeStore } from "@/stores/theme.store";

/**
 * Keeps document.documentElement in sync with the theme store so that
 * Tailwind's dark: variant and design system colors update everywhere.
 * Mount once at the app root (e.g. RootLayout).
 */
export function ThemeSync() {
  const theme = useThemeStore((s) => s.theme);
  const resolved = useThemeStore((s) => s.resolved);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", resolved === "dark");
    document.documentElement.setAttribute("data-theme", resolved);
  }, [theme, resolved]);

  return null;
}
